export default __webpack_public_path__ + "static/media/lead-score-toolbox-old.db3838dc.svg";